import React from "react";
import { useDispatch } from "react-redux";
import {
  Alert,
  AlertContainer,
  AlertContainerInner,
  AlertButtonContainer,
  Button,
} from "./styles";
import { ReducerState } from "../../types/alert";

const AlertComponent = ({ show, msg }: ReducerState) => {
  const dispatch = useDispatch();

  const handleOnClickClose = () => {
    dispatch({
      type: "CLOSE_ALERT",
    });
  };

  return show ? (
    <Alert>
      <AlertContainer>
        <AlertContainerInner>
          <span>{msg}</span>

          <AlertButtonContainer>
            <Button onClick={() => handleOnClickClose()}>
              <span>Close</span>
            </Button>
          </AlertButtonContainer>
        </AlertContainerInner>
      </AlertContainer>
    </Alert>
  ) : null;
};

export default AlertComponent;
